import { projectFirestore } from '../../firebase/config'
import { useEffect, useState } from 'react'

import JournalList from '../../components/JournalList'

// styles
import './Journal.css'
import { useTheme } from '../../hooks/useTheme'

export default function Journal() {
    const [data, setData] = useState(null)
    const [isPending, setIsPending] = useState(false)
    const [error, setError] = useState(false)
    const { mode } = useTheme()
    const [selectedCat, setSelectedCat] = useState("category")

    useEffect(() => {
        setIsPending(true)
        projectFirestore.collection("journals").orderBy("order", "asc").get().then((snapshot)=> {
         if (snapshot.empty) {
             setError('No journals to load')
             setIsPending(false)
         } else {
             let results = []
             snapshot.docs.forEach(doc => {
                 results.push({ id: doc.id, ...doc.data() })
             })
             setData(results)
             setIsPending(false)
         }
        }).catch(err => {
            setError(err.message)
            setIsPending(false)
        })
    }, [])

    return (
        <div className={`layout-journal ${mode}`}>
            <div className='header'>
                <h1>My Journal</h1>
                <p className='about'>A place where I record thoughts, plan designs, sketch ideas, and reflect. View my musings on Computer Science, making, STEAM and more.</p>
            </div>
            {error && <p className='error'>{error}</p>}
            {isPending && <p className='loading'>Loading...</p>}
            {data && 
            <div>
                <select
                    className='select-picker'
                    // value={selectedCat} // ...force the select's value to match the state variable...
                    onChange={e => setSelectedCat(e.target.value)} // ... and update the state variable on any change!
                    defaultValue="category"
                    >
                    <option value="category">choose a category</option>
                    <option value="class session">class session</option>
                    <option value="public art">public art</option>
                    <option value="museum visit">museum visit</option>
                    <option value="personal project">personal project</option>
                </select>
                <JournalList selectedCat={selectedCat} journals={data}/>
            </div>}
        </div>
    )
}